import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api phần event
export const getListEvent = (
    page_number = 1,
    page_size = 10,
    status = 0,
    textSearch = ''
) => {
    if (textSearch === '')
        return api.makeAuthRequest({
            url: `/event?page_number=${page_number}&page_size=${page_size}&deleted=${status}`,
            method: 'GET',
        })

    return api.makeAuthRequest({
        url: `/search/events?page_number=${page_number}&page_size=${page_size}&status=${status}&text=${textSearch}`,
        method: 'GET',
    })
}

export const getListEventAPI = (page_number, page_size, deleted) => {
    return api.makeAuthRequest({
        url: `/event?page_number=${page_number}&page_size=${page_size}&deleted=${deleted}`,
        method: 'GET',
    })
}
export const createNewEventAPI = (body = {}) => {
    return api.makeAuthRequest({
        url: `/event`,
        method: 'POST',
        data: body,
    })
}
export const getEventbyIdAPI = eid => {
    return api.makeAuthRequest({
        url: `/event/${eid}`,
        method: 'GET',
    })
}
export const updateEventbyIdAPI = (eid, body = {}) => {
    return api.makeAuthRequest({
        url: `/event/${eid}`,
        method: 'PUT',
        data: body,
    })
}
export const deleteEventbyIdAPI = eid => {
    return api.makeAuthRequest({
        url: `/event/${eid}`,
        method: 'DELETE',
    })
}
export const getListEventQuery = lst => {
    return api.makeAuthRequest({
        url: `/event/query/list?ids=${lst}`,
        method: 'GET',
    })
}
export const getListEventAboutTime = (begin_time, end_time) => {
    return api.makeAuthRequest({
        url: `/event/abouttime?page_number=${1}&page_size=${1000}&begin_time=${begin_time}&end_time=${end_time}`,
        method: 'GET',
    })
}
export const getDataExtEvent = (eid) => {
    return api.makeAuthRequest({
        url: `/event/${eid}/ext`,
        method: 'GET',
    })
}